export default {
  "Header": "_Header_18zgq_1"
};import "ni:sha-256;BEd8oBel9u_ZCKH9wl936QJuI6waApJIU8qcTONHT7c";